import { render, staticRenderFns } from "./support-notice.vue?vue&type=template&id=4f0fe591&scoped=true"
import script from "./support-notice.vue?vue&type=script&lang=js"
export * from "./support-notice.vue?vue&type=script&lang=js"
import style0 from "./support-notice.vue?vue&type=style&index=0&id=4f0fe591&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0fe591",
  null
  
)

export default component.exports